/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {Elastic, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {CreepyCarnivalTwoSoundConfig} from "../../CreepyCarnivalTwoSoundConfig";
import {CCTwoMultiplierEvents} from "../../multiplier/CCTwoMultiplierEvents";

export class CreepyCarnivalTwoInitialWinCountUp extends BaseView {

    protected _countUp:BitmapCountUp;
    protected _countUp_2:BitmapCountUp;
    protected _countUp_3:BitmapCountUp;
    protected _countUp_5:BitmapCountUp;
    protected _countUpContainer:PIXI.Sprite;
    private _isCountUpSoundPlaying:boolean = false;
    private _hasCountUpEndSoundPlayed:boolean = false;
    private _totalWinForThisSpin:number;
    private _totalWin:number;
    private _multiplier:number;

    private static _winBelowStake: boolean = false;
    public static set winBelowStake(value: boolean) {
        this._winBelowStake = value;
    }

    public getCountUpAnimation(from:number, to:number, duration:number, multiplier:number, totalWin:number):Timeline {
        this._totalWin = totalWin;
        this._totalWinForThisSpin = to;
        this._multiplier = multiplier;
        const timeline:TimelineLite = new TimelineLite();

        if(multiplier === 2) {
            return this.getCountUpFont(from, to, multiplier, duration, timeline, totalWin, this._countUp_2);
        } else if(multiplier === 3) {
            return this.getCountUpFont(from, to, multiplier, duration, timeline, totalWin, this._countUp_3);
        } else if(multiplier === 5) {
            return this.getCountUpFont(from, to, multiplier, duration, timeline, totalWin, this._countUp_5);
        } else {
            return this.getCountUpFont(from, to, multiplier, duration, timeline, totalWin, this._countUp);
        }
    }

    public abort(endValue:number, isAborted:boolean, multiplier:number, isBigWin:boolean):Timeline | null {
        if(isBigWin) {
            return null;
        }
        const timeline:TimelineLite = new TimelineLite();
        if(isAborted) {
            timeline.add(this.getAbortAnimation(endValue, multiplier));
        }
        timeline.add(this.getEndingAnimation(endValue));

        return timeline;
    }

    public getEndingAnimation(endValue:number):Timeline {
        // TODO: timeline.add(() => this.stopCountUpSound());
        if(this._multiplier === 2) {
            return this.getEndFont(endValue, this._countUp_2)
        } else if(this._multiplier === 3) {
            return this.getEndFont(endValue, this._countUp_3)
        } else if(this._multiplier === 5) {
            return this.getEndFont(endValue, this._countUp_5)
        } else {
            return this.getEndFont(endValue, this._countUp)
        }
    }

    protected initAnimations():void {
        this._countUp = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x1",
                    size : 13
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp_2 = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x2",
                    size : 13
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp_3 = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x3",
                    size : 13
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp_5 = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x5",
                    size : 13
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp.shrinkSize = true;
        this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp.visible = false;

        this._countUp_2.shrinkSize = true;
        this._countUp_2.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp_2.visible = false;

        this._countUp_3.shrinkSize = true;
        this._countUp_3.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp_3.visible = false;

        this._countUp_5.shrinkSize = true;
        this._countUp_5.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp_5.visible = false;

        // To use an extra container to make scale animations. the countUp has it's own scale calculation in animationConfig.
        this._countUpContainer = new PIXI.Sprite();
        this._countUpContainer.anchor.set(0.5, 0.5);
        this._countUpContainer.addChild(this._countUp);
        this._countUpContainer.addChild(this._countUp_2);
        this._countUpContainer.addChild(this._countUp_3);
        this._countUpContainer.addChild(this._countUp_5);

        this.addChild(this._countUpContainer);
    }

    protected getAbortAnimation(endValue:number, multiplier:number):Timeline {
        if(this._multiplier === 2) {
            return this.getAbortFont(endValue, multiplier, this._countUp_2)
        } else if(this._multiplier === 3) {
            return this.getAbortFont(endValue, multiplier, this._countUp_3)
        } else if(this._multiplier === 5) {
            return this.getAbortFont(endValue, multiplier, this._countUp_5)
        } else {
            return this.getAbortFont(endValue, multiplier, this._countUp)
        }
        return this.getAbortFont(endValue, multiplier, this._countUp);
    }

    private getScale(multiplier:number):number {
        return 1 + (multiplier - 1) * 0.1;
    }

    private getCountUpFont(from:number, to:number, multiplier:number, duration:number, timeline:Timeline, totalWin:number, font:BitmapCountUp):Timeline {
        let previousWins = totalWin - to;
        const oriNumber:number = MathHelper.roundToDecimals((to / multiplier), 2);

        // we have to play this sound only in free spin where multiplier is always 5
        // #312
        if(multiplier === 5 && !CreepyCarnivalTwoInitialWinCountUp._winBelowStake) {
            SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FS_WIN_3);
        }

        timeline.add([
            () => {
                font.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9 / this.getScale(multiplier);
                font.alpha = 1;
                font.visible = true;
                this._countUpContainer.scale.set(1, 1);
                if(duration > 0.01) {
                    this._isCountUpSoundPlaying = true;
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.NORMAL_WIN);
                }
            },
            font.getCountUpAnimation(from, oriNumber, {duration : duration, ease : Power3.easeInOut})
        ]);

        timeline.add(() => {
            SlotGame.sound.stopEffect(CreepyCarnivalTwoSoundConfig.instance.NORMAL_WIN);
        }, duration);

        // TODO: timeline.add(() => {this.stopCountUpSound();});

        if(multiplier > 1) {
            for(let m:number = 1; m <= multiplier; m++) {

                const showNumber:number = oriNumber * m;
                const scale:number = this.getScale(m);
                timeline.add([
                    () => {
                        if(m !== 1) {
                            this.updateMultiplier();
                        }

                        if(m === 1 && multiplier === 5) {
                            this.updateMultiplier();
                        }
                    },
                    this.onCountUpStart.bind(this, m),
                    font.getCountUpAnimation(showNumber, showNumber, {duration : 0.1}),
                    TweenLite.to(this._countUpContainer.scale, 0.3,
                        {
                            x : scale,
                            y : scale,
                            ease : Elastic.easeOut.config(2, 1)
                        }),
                ]);
                timeline.add(TweenLite.to(this, 0.3, {}));

                if(previousWins + showNumber == previousWins + this._totalWinForThisSpin) {
                    //will update after all font count up..
                    timeline.add(() => SlotGame.winFieldController.showWinField(previousWins + showNumber), timeline.totalDuration());
                }
            }
        }

        if(multiplier !== 5) {
            this.updateMultiplier();
        }

        // #312
        if (!CreepyCarnivalTwoInitialWinCountUp._winBelowStake) {
            switch (multiplier) {
                case 1:
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FS_WIN_1);
                    break;
                case 2:
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FS_WIN_2);
                    break;
                case 3:
                    SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.FS_WIN_3);
                    break;
            }
        }

        return timeline;
    }

    private onCountUpStart(multiplier:number):void {
        // #312
        if(multiplier === 1 || CreepyCarnivalTwoInitialWinCountUp._winBelowStake) {
            return;
        }

        SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.getWinAmountSoundName(multiplier));
    }

    private updateMultiplier() {
        EventHandler.dispatchEvent(new GameEvent(CCTwoMultiplierEvents.APPLY_MULTIPLIER));
    }

    private getAbortFont(endValue:number, multiplier:number, font:BitmapCountUp):Timeline {
        const timeline:TimelineLite = new TimelineLite();

        timeline.add([
            () => {
                font.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9 / this.getScale(multiplier);
                font.alpha = 1;
                font.visible = true;
                this._countUpContainer.scale.set(1, 1);
            },
            font.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        if(multiplier > 1) {
            const scale:number = this.getScale(multiplier);
            timeline.add(TweenLite.to(this._countUpContainer.scale, 0.2, {
                x : scale,
                y : scale,
                ease : Elastic.easeOut.config(2, 1)
            }), 0)
        }

        return timeline;
    }

    private getEndFont(endValue:number, font:BitmapCountUp):Timeline {
        const timeline:TimelineLite = new TimelineLite({
            onStart : () => {
                SlotGame.sound.stopEffect(CreepyCarnivalTwoSoundConfig.instance.NORMAL_WIN);
            },
            onComplete : () => {
                this._isCountUpSoundPlaying = false;
                this._hasCountUpEndSoundPlayed = false;
            }
        });
        timeline.add(font.getCountUpAnimation(endValue, endValue, {duration : 0.5}));
        timeline.add(TweenLite.to(font, 0.5, {alpha : 0})); // stay a while after count up.

        return timeline;
    }
}